<template>
  <div id="app">
    <Loading v-if="state.loading" />
    <Navbar v-if="!state.token" />
    <DashNavbar
      style="position: fixed"
      v-if="
        state.token &&
        !$route.path.includes('dashboard') &&
        !$route.path.includes('advancetrade')
      "
    />
    <div v-if="showPWA" class="pwa-box">
      <button class="close" @click="showPWA = false">&times;</button>
      <p>سه سوت سه‌سوت چنج رو نصب کن</p>
      <div>
        <button class="install" @click="installPWA()">نصب سه‌سوت چنج</button>
      </div>
    </div>
    <div
      :class="[
        !state.token
          ? 'mt-73'
          : state.token &&
            !$route.path.includes('dashboard') &&
            !$route.path.includes('advancetrade')
          ? 'mt-56'
          : '',
      ]"
    >
      <router-view />
    </div>
    <Footer v-if="!(isTWA || isPWA) && showFooter" />
    <TWAFooter v-if="isTWA || isPWA" />
    <!-- <PWA /> -->
  </div>
</template>

<script>
import Navbar from "./components/Public/Navbar.vue";
import Footer from "./components/Public/Footer.vue";
import TWAFooter from "./components/Public/TWAFooter.vue";
import Loading from "./components/Public/Loading.vue";
import DashNavbar from "./components/Panel/DashNavbar.vue";
// import PWA from "./PWA.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    TWAFooter,
    Loading,
    DashNavbar,
    // PWA,
  },
  data() {
    return {
      showPWA: false,
      defferedPrompt: null,
      isTWA: process.env?.VUE_APP_ISTWA,
      isPWA: window.matchMedia("(display-mode: standalone)").matches,
    };
  },
  // mounted() {
  //   if (this.state.theme === "dark") {
  //     document.body.classList.add("dark");
  //   }
  // },
  computed: {
    showFooter() {
      return (
        this.$route.name == "AboutUs" ||
        this.$route.name == "Faq" ||
        this.$route.name == "Fee" ||
        this.$route.name == "Market" ||
        this.$route.name == "PrivacyAndPolicy" ||
        this.$route.name == "HomePage"
      );
    },
  },
  methods: {
    installPWA() {
      console.log(window.deferredPrompt);
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // user accept the prompt

          // lets hidden button
          this.showPWA = false;
        } else {
          console.log("User dismissed the prompt");
        }
        window.deferredPrompt = null;
      });
    },
  },
  async mounted() {
    window.deferredPrompt = {};

    // if the app can be installed emit beforeinstallprompt
    window.addEventListener("beforeinstallprompt", (e) => {
      // this event does not fire if the application is already installed
      // then your button still hidden ;)

      // show button with display:block;
      this.showPWA = true;

      // prevent default event
      e.preventDefault();

      // store install avaliable event
      window.deferredPrompt = e;
    });

    // if are standalone android OR safari
    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    ) {
      // hidden the button
      this.showPWA = false;
    }

    // do action when finished install
    window.addEventListener("appinstalled", () => {
      console.log("success app install!");
    });
  },
};
/*TODO testing yadegari website for presentation:
 * finotech
 * wallets
 * trades
 * stop-limit stop-market
 * */
</script>

<style lang="scss" scoped>
.mt-73 {
  margin-top: 73px;
}
.mt-56 {
  margin-top: 56px;
}
.pwa-box {
  position: fixed;
  bottom: 20px;
  left: 20px;
  // transform: translateX(-50%);
  background-color: var(--box);
  box-shadow: 4px 4px 8px #aaa;
  color: var(--dark-grey);
  z-index: 100000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: calc(100% - 40px);
  max-width: 320px;
  padding: 16px;
  border-radius: 8px;
  .install {
    padding: 8px 16px;
    background-color: var(--primary-color);
    color: var(--white);
    border-radius: 8px;
    display: block;
  }
  .close {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background-color: var(--box);
    box-shadow: 2px 2px 4px #aaa;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
}
</style>
